import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';

import BackdropCircularProgress from '../../components/BackdropCircularProgress';
import FormCloseButton from '../../components/Form/FormCloseButton';
import theme from '../../theme';
import { ROUTE_CONSTANTS } from '../app/RouteBuilding/routeConstants';

import RosterPanel from './RosterPanel/RosterPanel';
import JobOrderDetailLeft from './JobOrderDetailLeft';
import {
  clearCancelledPlacementData,
  getJobOrderDetailV2,
  setJobOrderDetailV2,
} from './jobOrderDetailReducer';
import {
  selectIsJobOrderDetailLoadingV2,
  selectIsJobOrderDetailUpdatedV2,
  selectJobOrderDetailV2,
} from './jobOrderDetailSelectors';

const JobOrderDetailPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const jobOrderDetail = useSelector(selectJobOrderDetailV2);
  const isJobOrderDetailLoading = useSelector(selectIsJobOrderDetailLoadingV2);
  const isJobOrderDetailUpdated = useSelector(selectIsJobOrderDetailUpdatedV2);

  const { id } = useParams();

  useEffect(() => {
    dispatch(getJobOrderDetailV2({ jobId: id }));
    return () => {
      dispatch(setJobOrderDetailV2({}));
      dispatch(clearCancelledPlacementData());
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (isJobOrderDetailUpdated) {
      dispatch(getJobOrderDetailV2({ jobId: id }));
    }
  }, [dispatch, isJobOrderDetailUpdated, id]);

  return (
    <Box
      sx={{
        height: '100vh',
        padding: '25px',
        display: 'flex',
        flexDirection: 'column',
        gap: '36px',
      }}
    >
      {isJobOrderDetailLoading && <BackdropCircularProgress />}
      <FormCloseButton
        onClose={() => navigate(`/${ROUTE_CONSTANTS.JOB_ORDERS}${location.search}`)}
        message="buttonText.goBack"
      />
      <Grid container sx={{ height: '100%' }}>
        <Grid
          item
          xs={12}
          md={3}
          sx={{
            backgroundColor: `${theme?.components?.detailLeft?.palette?.backgroundColor}`,
            padding: '16px',
            display: 'flex',
            justifyContent: 'center',
            minWidth: '300px',
          }}
        >
          <JobOrderDetailLeft />
        </Grid>
        <Grid item xs={12} md={9} sx={{ padding: 2 }}>
          {jobOrderDetail?.id && <RosterPanel jobOrder={jobOrderDetail} />}
        </Grid>
      </Grid>
    </Box>
  );
};

export default JobOrderDetailPage;
